/**
 * Fushat e pagës te forma e kontratës — lidhja mes tyre dhe normat e periudhës.
 *
 * Formula është te salaryCalc (contractPayFromBase / contractPayFromHourly), e
 * njëjta që përdor lista e pagave; këtu vetëm merren normat e politikës fiskale
 * aktuale dhe zbatohen te forma.
 */
import { useEffect, useState } from 'react';
import apiService from '../services/apiServices';
import { pickFiscalPolicy } from './fiscalPolicy';
import { contractPayFromBase, contractPayFromHourly } from './salaryCalc';

const LAW_DEFAULTS = { WeekendRate: 50, HolidayRate: 50, MinimumWage: 0 };

/** Normat e shtesave dhe paga minimale nga «Politikat Fiskale» për sot. */
export function useContractPayRates() {
  const [rates, setRates] = useState(LAW_DEFAULTS);
  useEffect(() => {
    let alive = true;
    apiService().get('fiscalPoliciesExt')
      .then((r) => {
        const p = pickFiscalPolicy(r?.success ? r.data : [], new Date().toISOString().slice(0, 10));
        if (alive && p) {
          setRates({
            WeekendRate: p.WeekendRate ?? 50,
            HolidayRate: p.HolidayRate ?? 50,
            MinimumWage: Number(p.MinimumWage) || 0,
          });
        }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return rates;
}

/**
 * Kur ndryshon paga bazë ose ajo për orë, plotëson të tjerat.
 * Fusha që po shkruhet nuk preket — rrumbullakimi s'ia prish shkrimin njeriut.
 */
export function applyPayChange(setValue, source, rawValue, rates) {
  const next = source === 'HourSalary'
    ? contractPayFromHourly(rawValue, rates)
    : contractPayFromBase(rawValue, rates);
  Object.entries(next).forEach(([k, v]) => {
    if (k !== source) setValue(k, v === '' ? '' : String(v), { shouldDirty: true });
  });
}

/** Te një kontratë e ruajtur me vetëm pagë bazë, plotëson fushat bosh të orës. */
export function fillMissingHourly(getValues, setValue, rates) {
  const base = getValues('BaseSalary');
  if (!Number(base)) return;
  const next = contractPayFromBase(base, rates);
  ['HourSalary', 'HourSalaryWeekend', 'HourSalaryHoliday'].forEach((k) => {
    if (!Number(getValues(k))) setValue(k, String(next[k]));
  });
}
